<template>
  <b-card class="mb-5">
    <b-row class="mb-2">
      <b-col md="6">
        <h3>{{ $route.name }}</h3>

        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>

      <b-col md="6">
        <b-button variant="primary" class="float-right btn-custom" :to="'delivery-order/create'"
          ><font-awesome-icon icon="plus"
        /></b-button>
        <b-button @click="showModalExport" variant="success" v-b-tooltip.hover.left class="float-right btn-custom mr-4" title="Export Report Monthly"> <font-awesome-icon icon="download"/></b-button>
      </b-col>
    </b-row>
    <div class="border-bottom"></div>

    <!-- search box filter -->
    <b-form v-on:submit.prevent="doFilter">
      <b-row>
        <b-col md="12">
          <b-row class="mb-3 mb-1">
            <b-col md="3 mt-2">
              <b-form-input
                v-model="tableFilter.customer_name"
                customQueryParamName="search"
                placeholder="Search Customer Name"
              />
            </b-col>

            <b-col md="3 mt-2">
              <b-form-input placeholder="Number" v-model="tableFilter.number" />
            </b-col>

            <b-col md="2 mt-2">
              <b-form-select v-model="tableFilter.statusReceipt" :options="statusList" />
            </b-col>
            <b-col md="2 mt-2">
              <date-picker
                v-model="tableFilter.date"
                type="date"
                placeholder="Date Created"
              ></date-picker>
            </b-col>

            <b-col md="2 mt-2">
              <!-- button filter -->
              <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search">
                <font-awesome-icon icon="search" />Filter
              </button>
              <!-- end button -->

              <!-- button clear filter -->
              <button
                @click="clearFilter()"
                class="ml-0 btn btn-outline-primary float-right"
                id="btn-search"
              >
                <font-awesome-icon icon="times-circle" /> Clear Filter
              </button>
              <!-- end button -->
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <!-- end search  -->

    <!-- table paginate -->
    <paginated-table
      ref="dataTable"
      :can-delete="false"
      :can-paid="false"
      :can-edit="true"
      :can-approve="false"
      :can-reject="true"
      :data-url="apiUrl.receipt"
      :data-key="dataKey"
      :data-columns="columns"
      :data-params="['search', 'customer_name', 'number', 'status', 'start_date']"
    >
      <template slot="content_receipt" slot-scope="defaultSlotScope">
        {{ defaultSlotScope }}
      </template>
    </paginated-table>
    <!-- end table -->
    <modal-export ref="modalExport"></modal-export>
  </b-card>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import PaginatedTable from '../../../components/PaginatedTable.vue';
import ModalExport from './ModalExport.vue';

export default {
  name: 'report-index',

  components: {
    DatePicker,
    PaginatedTable,
    ModalExport,
  },

  data() {
    return {
      dataKey: 'receipt',
      apiUrl: {
        receipt: window.AppConfig.apiUrl + 'receipt',
        receiptItem: window.AppConfig.apiUrl + 'item',
        exportReceipt: window.AppConfig.apiUrl + 'export-receipt-pdf',
      },
      receiptList: [
        {
          value: null,
          text: 'Type',
        },
      ],
      statusList: [
        {
          value: null,
          text: 'Status',
        },
        {
          value: 'Created',
          text: 'Created',
        },
        {
          value: 'Shipping',
          text: 'Shipping',
        },
        {
          value: 'Received',
          text: 'Received',
        },
        {
          value: 'Cancel',
          text: 'Cancel',
        },
      ],
      columns: [
        {
          key: 'customer',
          label: 'Customer',
          sortable: true,
        },
        {
          key: 'number',
          label: 'Number',
          sortable: true,
        },
        {
          key: 'createdAt',
          label: 'Create Date',
          sortable: true,
        },
        {
          key: 'createdBy',
          label: 'Created By',
          sortable: true,
        },
        
        {
          key: 'shippedBy',
          label: 'Shipped By'
        },
        {
          key: 'receivedBy',
          label: 'Received By',
          sortable: true,
        },

        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'actionReceiptIndex',
          label: '',
        },
      ],
      tableFilter: {
        receiptItem: null,
        customer_name: this.$route.query.customer_name,
        status: this.$route.query.status,
        statusReceipt: null,
        customer_uuid: this.$route.query.customer_uuid,
        number: this.$route.query.number,
        date: null,
        start_date: this.$route.query.start_date,
        end_date: this.$route.query.end_date,
      },
    };
  },

  watch: {
    'tableFilter.customer_name'() {
      this.doFilter();
    },
  },

  mounted() {
    /** call function for get data from API */
    this.getReceiptItem();
  },

  methods: {
    /** get data receipt from API */
    getReceiptItem() {
      this.$http.get(this.apiUrl.receipt + '?limit=100').then((resp) => {
        resp.data._embedded.receipt.forEach((data) => {
          this.receiptList.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },

    doFilter() {
      // eslint-disable-next-line no-self-assign
      this.tableFilter.customer_name = this.tableFilter.customer_name;
      // eslint-disable-next-line no-self-assign
      this.tableFilter.number = this.tableFilter.number;
      this.tableFilter.status = this.tableFilter.statusReceipt;
      this.tableFilter.start_date =
        this.tableFilter.date !== null
          ? this.$moment(this.tableFilter.date).format('YYYY-MM-DD')
          : null;
      // this.tableFilter.ot_end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
      this.$refs.dataTable.doFilter(this.tableFilter);
    },

    clearFilter() {
      this.tableFilter.customer_name = null;
      this.tableFilter.statusReceipt = null;
      this.tableFilter.number = null;
      this.tableFilter.date = null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },

    /**
     * funtion to showModal EXport
     */
    showModalExport(modal){
      this.$refs.modalExport.showModal(modal)
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm');
      } else {
        return '-';
      }
    },

    /** colores status  */
    getStatusColor(val) {
      switch (val) {
        case 'Requested':
          return 'warning';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Resolved':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
  },
};
</script>
